import { Box, Button, Dialog, IconButton, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { brand } from "../../../theme";

// Политика ООО «РБР» в отношении обработки персональных данных.
// При замене файла меняйте v=, иначе браузеры покажут старую версию из кэша.
export const POLICY_TITLE = "Политика в отношении обработки персональных данных в ООО «РБР»";
export const POLICY_PDF_URL = "/Files/Политика ПД РБР.pdf?v=20260921";
export const POLICY_DOWNLOAD_NAME = "Политика обработки персональных данных ООО РБР.pdf";

type Props = {
  open: boolean;
  onClose: () => void;
  title: string;
  src: string;
  downloadName?: string;
};

export default function PdfViewerDialog({ open, onClose, title, src, downloadName }: Props) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg" PaperProps={{ sx: { height: "90vh", overflow: "hidden" } }}>
      <Stack direction="row" alignItems="center" gap={1} sx={{ px: 2.5, py: 1.5, borderBottom: `1px solid ${brand.line}` }}>
        <Typography variant="h6" sx={{ flexGrow: 1, minWidth: 0, fontSize: 17 }} noWrap title={title}>
          {title}
        </Typography>
        <Button size="small" variant="outlined" startIcon={<DownloadIcon />} href={src} download={downloadName ?? true} sx={{ flexShrink: 0 }}>
          Скачать
        </Button>
        <IconButton href={src} target="_blank" rel="noopener" title="Открыть в новой вкладке" aria-label="Открыть в новой вкладке">
          <OpenInNewIcon />
        </IconButton>
        <IconButton onClick={onClose} aria-label="Закрыть">
          <CloseIcon />
        </IconButton>
      </Stack>
      <Box component="iframe" src={src} title={title} sx={{ flexGrow: 1, width: "100%", border: 0, bgcolor: "#525659" }} />
    </Dialog>
  );
}
